import React from "react";
import imageUrl from "../assets/images/footerlogo.png";
import { IoLocation, IoCall, IoMail } from "react-icons/io5";
import { IoMdClock } from "react-icons/io";

function Footer() {
  return (
    <section className="py-12 bg-black sm:pt-16 lg:pt-24">
      <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-2 md:col-span-3 lg:grid-cols-6 gap-y-16 gap-x-12">
          <div className="col-span-2 md:col-span-3 lg:col-span-2 lg:pr-8">
            <img className="w-auto h-[100px]" src={imageUrl} alt="" />
            <ul className="flex items-center space-x-3 mt-9">
              <li>
                <a
                  href="https://www.tiktok.com/@xtremetunings.nl"
                  title="TikTok"
                  className="flex items-center justify-center text-white transition-all duration-200 bg-gray-800 rounded-full w-7 h-7 hover:bg-[#ff0000] focus:bg-[#ff0000]"
                >
                  <svg
                    className="w-4 h-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="white"
                  >
                    <path d="M12 2c1.1 0 2 .9 2 2v10c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3V8c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6V8c1.3.8 2.8 1.3 4 1.3V6c-1.3 0-2.7-.4-4-1.3V4c0-1.1-.9-2-2-2h-2z" />
                  </svg>
                </a>
              </li>

              <li>
                <a
                  href="https://www.facebook.com/xtremetunings/"
                  title="Facebook"
                  className="flex items-center justify-center text-white transition-all duration-200 bg-gray-800 rounded-full w-7 h-7 hover:bg-[#ff0000] focus:bg-[#ff0000]"
                >
                  <svg
                    className="w-4 h-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"></path>
                  </svg>
                </a>
              </li>

              <li>
                <a
                  href="https://www.instagram.com/xtremetunings.nl/"
                  title="Instagram"
                  className="flex items-center justify-center text-white transition-all duration-200 bg-gray-800 rounded-full w-7 h-7 hover:bg-[#ff0000] focus:bg-[#ff0000]"
                >
                  <svg
                    className="w-4 h-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M11.999 7.377a4.623 4.623 0 1 0 0 9.248 4.623 4.623 0 0 0 0-9.248zm0 7.627a3.004 3.004 0 1 1 0-6.008 3.004 3.004 0 0 1 0 6.008z"></path>
                    <circle cx="16.806" cy="7.207" r="1.078"></circle>
                    <path d="M20.533 6.111A4.605 4.605 0 0 0 17.9 3.479a6.606 6.606 0 0 0-2.186-.42c-.963-.042-1.268-.054-3.71-.054s-2.755 0-3.71.054a6.554 6.554 0 0 0-2.184.42 4.6 4.6 0 0 0-2.633 2.632 6.585 6.585 0 0 0-.419 2.186c-.043.962-.056 1.267-.056 3.71 0 2.442 0 2.753.056 3.71.015.748.156 1.486.419 2.187a4.61 4.61 0 0 0 2.634 2.632 6.584 6.584 0 0 0 2.185.45c.963.042 1.268.055 3.71.055s2.755 0 3.71-.055a6.615 6.615 0 0 0 2.186-.419 4.613 4.613 0 0 0 2.633-2.633c.263-.7.404-1.438.419-2.186.043-.962.056-1.267.056-3.71s0-2.753-.056-3.71a6.581 6.581 0 0 0-.421-2.217zm-1.218 9.532a5.043 5.043 0 0 1-.311 1.688 2.987 2.987 0 0 1-1.712 1.711 4.985 4.985 0 0 1-1.67.311c-.95.044-1.218.055-3.654.055-2.438 0-2.687 0-3.655-.055a4.96 4.96 0 0 1-1.669-.311 2.985 2.985 0 0 1-1.719-1.711 5.08 5.08 0 0 1-.311-1.669c-.043-.95-.053-1.218-.053-3.654 0-2.437 0-2.686.053-3.655a5.038 5.038 0 0 1 .311-1.687c.305-.789.93-1.41 1.719-1.712a5.01 5.01 0 0 1 1.669-.311c.951-.043 1.218-.055 3.655-.055s2.687 0 3.654.055a4.96 4.96 0 0 1 1.67.311 2.991 2.991 0 0 1 1.712 1.712 5.08 5.08 0 0 1 .311 1.669c.043.951.054 1.218.054 3.655 0 2.436 0 2.698-.043 3.654h-.011z"></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-sm font-semibold tracking-widest text-white uppercase">
              Quick Links
            </p>

            <ul className="mt-6 space-y-4">
              <li>
                <a
                  href="/Services"
                  title=""
                  className="flex text-base text-white transition-all duration-200 hover:text-[#ff0000] focus:text-[#ff0000]"
                >
                  {" "}
                  Services{" "}
                </a>
              </li>

              <li>
                <a
                  href="/Gallery"
                  title=""
                  className="flex text-base text-white transition-all duration-200 hover:text-[#ff0000] focus:text-[#ff0000]"
                >
                  {" "}
                  Gallery{" "}
                </a>
              </li>

              <li>
                <a
                  href="/Contact-Us"
                  title=""
                  className="flex text-base text-white transition-all duration-200 hover:text-[#ff0000] focus:text-[#ff0000]"
                >
                  {" "}
                  Contact Us{" "}
                </a>
              </li>
              <li>
                <a
                  href="/terms-and-conditions"
                  title=""
                  className="flex text-base text-white transition-all duration-200 hover:text-[#ff0000] focus:text-[#ff0000]"
                >
                  {" "}
                  Terms & Conditions{" "}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-sm font-semibold tracking-widest text-white uppercase">
              Services
            </p>

            <ul className="mt-6 space-y-4">
              <li>
                <a
                  href="/Chip-Tuning"
                  title=""
                  className="flex text-base text-white transition-all duration-200 hover:text-[#ff0000] focus:text-[#ff0000]"
                >
                  {" "}
                  Chiptuning{" "}
                </a>
              </li>

              <li>
                <a
                  href="/EGR-Solutions"
                  title=""
                  className="flex text-base text-white transition-all duration-200 hover:text-[#ff0000] focus:text-[#ff0000]"
                >
                  {" "}
                  EGR Solutions{" "}
                </a>
              </li>

              <li>
                <a
                  href="/Hard-Rev-Cut"
                  title=""
                  className="flex text-base text-white transition-all duration-200 hover:text-[#ff0000] focus:text-[#ff0000]"
                >
                  {" "}
                  Hard Rev Cut{" "}
                </a>
              </li>
              <li>
                <a
                  href="/DTC-Removal"
                  title=""
                  className="flex text-base text-white transition-all duration-200 hover:text-[#ff0000] focus:text-[#ff0000]"
                >
                  {" "}
                  DTC Removal{" "}
                </a>
              </li>
              <li>
                <a
                  href="/DSG-Tuning"
                  title=""
                  className="flex text-base text-white transition-all duration-200 hover:text-[#ff0000] focus:text-[#ff0000]"
                >
                  {" "}
                  DSG / AUTOMAAT TUNING{" "}
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-2 md:col-span-1 lg:col-span-2 lg:pl-8">
            <p className="text-sm font-semibold tracking-widest text-white uppercase">
              Information
            </p>
            <ul className="mt-6 space-y-4">
              <li className="flex items-center text-white">
                <IoLocation className="mr-2" /> Industrieweg 1-37 2712 LA
                Zoetermeer
              </li>
              <li className="flex items-center text-white">
                <IoCall className="mr-2" /> 06 13 10 00 91
              </li>
              <li className="flex items-center text-white">
                <IoMail className="mr-2" /> info@x-tremetunings.nl
              </li>
            </ul>
            <p className="flex mt-6 text-sm font-semibold tracking-widest text-white uppercase">
              <IoMdClock className="mr-2" />
              Office Hours
            </p>
            <table className="text-white ml-5">
              <tbody>
                <tr>
                  <td>Monday - Friday: </td>
                  <td className="ml-3">10:00 - 18:00</td>
                </tr>
                <tr>
                  <td>Saturday: </td>
                  <td>10:00 - 18:00</td>
                </tr>
                <tr>
                  <td>Sunday: </td>
                  <td>Closed</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <hr className="mt-16 mb-10 border-gray-200" />

        <p className="text-sm text-center text-white flex justify-between">
          <span className="text-center">Copyright© 2026 X-TREMETUNING</span>
          <span>
            <a href="https://itsolutionsworldwide.com" target="_blank" rel="noreferrer">
              Developed <i></i>by IT Solutions Worldwide
            </a>
          </span>
        </p>
      </div>
    </section>
  );
}

export default Footer;
